// src/components/pages/Login/AuthPage.jsx
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Login from "./Login";
import Register from "@components/Register/Register"; // alias used
import Promotions from "@components/home/Promotions/Promotions";

import authStyles from "@components/Auth/Auth.module.css";
import pageStyles from "./AuthPage.module.css";
import SatelliteAnimation from "@/components/SatelliteAnimation/SatelliteAnimation";

export default function AuthPage() {
  const location = useLocation();
  const [isLoginPath, setIsLoginPath] = useState(location.pathname === '/login');

  useEffect(() => {
    setIsLoginPath(location.pathname === '/login');
  }, [location.pathname]);

  return (
    <main className={authStyles.authContainer}>

      {/* Auth card */}
      <section className={authStyles.centerStage}>
          {isLoginPath ? (
            <Login />
          ) : (
            <Register />
          )}
      </section>

      {/* Cinematic Background */}
      <section className='w-full h-fit flex justify-center'>
        <SatelliteAnimation />
      </section>

      {/* Promotions Section */}
      <section className={pageStyles.promotionSection}>
        <Promotions />
      </section>
      {/* Footer removed - already rendered globally in App.jsx */}
    </main>
  );
}
